// GraficoCrescimento.js
//
// Gráfico de crescimento da escola: três linhas (alunos, professores,
// turmas) no eixo Y, e a quantidade de aulas registradas no eixo X.
//
// Dados vêm de escolas/{idEscola}/historicoCrescimento (ver
// fetchHistoricoCrescimento em dashboardData.js e o trigger
// registrarHistoricoCrescimento em backend/dashboard.js), que grava um
// ponto a cada aula fechada. Por isso o gráfico só aparece quando já
// existe pelo menos 2 pontos — com 0 ou 1 aula fechada não há "evolução"
// nenhuma pra mostrar ainda.

import React from 'react';
import { TrendingUp } from 'lucide-react';
import {
  ResponsiveContainer, LineChart, Line,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

const CORES = {
  alunos: '#3b82f6',
  professores: '#f59e0b',
  turmas: '#10b981',
};

export default function GraficoCrescimento({ historico }) {
  if (!historico || historico.length < 2) return null;

  return (
    <div className="chart-card">
      <h2 className="chart-title">
        <TrendingUp size={18} color="#3b82f6" /> Crescimento da escola
      </h2>
      <div style={{ width: '100%', height: 280 }}>
        <ResponsiveContainer>
          <LineChart data={historico} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
            <XAxis
              dataKey="numAulasRegistradas"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#64748b' }}
              label={{ value: 'Aulas registradas', position: 'insideBottom', offset: -5, fontSize: 12, fill: '#64748b' }}
            />
            <YAxis axisLine={false} tickLine={false} allowDecimals={false} tick={{ fontSize: 12, fill: '#64748b' }} />
            <Tooltip
              contentStyle={{ borderRadius: 8, border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
              labelFormatter={(valor) => `Aula nº ${valor}`}
            />
            <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="numAlunos" name="Alunos" stroke={CORES.alunos} strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="numProfessores" name="Professores" stroke={CORES.professores} strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="numTurmas" name="Turmas" stroke={CORES.turmas} strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
